export default function getFuelLogKey(vehicleGuid, year) {
  return `${year}_${vehicleGuid}`;
}
